import React from 'react';
import { Row, Col } from 'react-bootstrap';

import * as Yup from 'yup';

import {
  Formik,
  Form as FormikForm,

} from 'formik';
import {
  TextField,
  SelectFieldV2,
  CancelPopupButton,
  SubmitButton,
  CheckBoxField,
} from 'ui/FormElement';
import useCountries from 'components/Common/Countries/Hooks/useCountries';
import Modal from '../../../ui/Modal';

import { useContext as usePaymentMethodsContext } from './Context';

export default function Form({ show, onHide, initValue }) {
  const {
    state: paymentMethodsState,
    actions: paymentMethodsActions,
    dispatch: paymentMethodsDispatch,
  } = usePaymentMethodsContext();

  const { countries } = useCountries();

  const FormSchema = Yup.object().shape({
    name: Yup.string().required('Note is required'),
    email: Yup.string().required('Email is required'),
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    paymentMethodsActions.savePaymentMethod(
      paymentMethodsDispatch,
      paymentMethodsState.enterpriseId,
      initValue.id,
      values,
      () => {
        setSubmitting(false);
        onHide();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show={show} onHide={onHide} header="Payment Method">
      {initValue.id !== '' && (
      <p>
        Linked Plans:
        {' '}
        {initValue.attributes.plans_names == '' ? 'No Plans Linked To Payment' : initValue.attributes.plans_names }
      </p>
      )}
      <Formik
        enableReinitialize
        validationSchema={FormSchema}
        initialValues={{
          name: initValue.attributes.name,
          email: initValue.attributes.email,
          country: initValue.attributes.country,
          city: initValue.attributes.city,
          address_line1: initValue.attributes.address_line1,
          address_line2: initValue.attributes.address_line2,
          postal_code: initValue.attributes.postal_code,
          draft_invoice: initValue.attributes.draft_invoice,
          invoice_footer: initValue.attributes.invoice_footer,
          invoice_memo: initValue.attributes.invoice_memo,
        }}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">

            <div>
              <TextField
                name="name"
                label={(
                  <>
                    <span>Bill To</span>
                    <abbr title="required">*</abbr>
                  </>
                )}
              />

              <TextField
                name="email"
                label={(
                  <>
                    <span>Email</span>
                    <abbr title="required">*</abbr>
                  </>
                )}
              />

              <SelectFieldV2
                name="country"
                placeholder={countries === null ? 'Loading Country ...' : 'Choose Country'}
                isMulti={false}
                options={countries || []}
                label={(
                  <span>Country</span>
                )}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                }}
                menuPortalTarget={document.body}
              />

              <TextField
                name="city"
                label={(
                  <span>City</span>
                )}
              />

              <TextField
                name="address_line1"
                label={(
                  <span>Address Line 1</span>
                )}
              />

              <TextField
                name="address_line2"
                label={(
                  <span>Address Line 2</span>
                )}
              />

              <TextField
                name="postal_code"
                label={(
                  <span>Postal Code</span>
                )}
              />

              <TextField
                name="invoice_memo"
                as="textarea"
                label={(
                  <span>Invoice Memo</span>
                )}
              />

              <TextField
                name="invoice_footer"
                as="textarea"
                label={(
                  <span>Invoice Footer</span>
                )}
              />

              <CheckBoxField
                name="draft_invoice"
                inline
                label={(
                  <span>Generate Draft Invoice</span>
                )}
              />

            </div>

            <div className="mt50 mb30">
              <Row>
                <Col md={6}>
                  <CancelPopupButton
                    className="btn btn-primary btn-outline mr5 ml5 width-120"
                    title="Cancel"
                    onClick={() => onHide()}
                  />
                </Col>
                <Col md={6} className="text-right">
                  <SubmitButton
                    title={`${isSubmitting ? 'Saving ...' : 'Save'}`}
                    className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                      isSubmitting ? 'not-possible-click' : ''
                    }`}
                  />
                </Col>
              </Row>
            </div>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}
